/* eslint-disable import/no-default-export */
/* eslint-disable react/prop-types */
import React from 'react';
import ImageLoader from 'react-render-image';

export default function ReactRenderImage(props) {
	// Produce the image tag as is because there is no onLoad event in SSR
	// Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
	// This will make image flicker
	// oxlint-disable-next-line react-js/prop-types
	return props.src &&
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		(process.env.REACT_SSR || window.__SSR_RENDERED__) ? (
		// oxlint-disable-next-line react-js/prop-types
		<>{props.loaded}</>
	) : (
		<ImageLoader {...props} />
	);
}
